import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Header from './Header';
import Body from './Body';

const styles = () => ({
  root: {},
  header: {},
  body: {},
});

const Content = ({
  className,
  classes,
  lineItemResource,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Header
        className={classes.header}
        lineItemResource={lineItemResource}
      />
      <Body
        className={classes.body}
        lineItemResource={lineItemResource}
      />
    </Box>
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lineItemResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
